// Compare package types while making them all lower case
export function comparePackageTypes(type1, type2) {
  return typeof type1 === 'string' && typeof type2 === 'string' && type1.toLowerCase() === type2.toLowerCase();
}
